<template>
  <div class="agreement">
    <AppNavbar
      :zIndex="999"
      :placeholder="true"
      title="会员协议"
      :backCallback="bindBack"
    ></AppNavbar>
    <div class="bold line"
      >【请认真阅读并理解以下内容，其中以加粗方式显著标识的文字，请着重阅读、慎重考虑。】</div
    >
    <div class="line">
      本协议是您与{{ appName }}运营者（下称"{{ appName }}"）之间就{{
        appName
      }}会员所订立的契约。<span class="bold"
        >请您仔细阅读本协议，您点击"同意并继续"按钮后，本协议即构成对双方有约束力的法律文件。未成年人应在监护人监护、指导下阅读并决定是否同意本协议。</span
      >
    </div>

    <div class="line"
      >本协议是基于 《{{ appName }}用户协议》以及《{{ appName }}隐私协议》等{{
        appName
      }}相关协议规范制定，是其不可分割的一部分；本协议如与前述协议发生冲突的，以本协议为准。{{
        appName
      }}已有和未来不时发布的与会员服务相关的协议、各类公告、页面说明和规范流程、问题解答等内容均构成本协议的部分，与本协议具有同等法律效力。{{
        appName
      }}与WE+减脂会员均都应当受本协议以及《{{ appName }}用户协议》以及《{{
        appName
      }}隐私协议》的约束。
    </div>
    <div class="title">第1条 相关定义</div>
    <div class="line">
      本协议的会员包含普通会员及WE+减脂会员。其中普通会员指在{{
        appName
      }}app完成注册并在{{ appName }}绑定手机号的用户，WE+减脂会员是指在{{
        appName
      }}APP完成注册并在{{
        appName
      }}绑定手机号的同时/之后，通过支付费用或积分兑换等方式升级后，享受"WE+减脂会员专享"增值服务的用户（具体以会员中心展示的权益内容为准）。
    </div>
    <div class="title">第2条 本站服务条款的确认和接纳</div>
    <div class="line"
      >2.1本站所提供的会员活动的所有权和运作权归{{ appName }}所有。</div
    >
    <div class="line"
      >2.2用户点击同意本协议的，即视为用户确认自己同意接受会员相关服务的条款，同意按本协议内容履行，如产生用户相关责任的，同意承担相应法律责任。</div
    >
    <div class="line"
      >2.3如果您在18周岁以下，您只能在父母或监护人的监护参与下方能参与体验该服务。</div
    >
    <div class="line"
      >2.4
      {{
        appName
      }}保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容等相关权利。</div
    >
    <div class="line"
      >2.5减脂会员开通后，您在已开通的服务期内中途主动取消服务或终止资格的，将不获得为开通本服务而支付费用的退还。</div
    >
    <div class="line"
      >2.6减脂会员开通后，会员权益仅限本人使用，不可转赠他人，如因账号问题需要迁移权益，需注销后方可迁移到新账号。</div
    >
    <div class="line"
      >2.7
      {{
        appName
      }}在为WE+减脂会员提供多项专属特权和增值服务时，可能会获取减脂会员的部分信息，{{
        appName
      }}深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控（详情请见《{{
        appName
      }}隐私协议》），如您继续开通WE+减脂会员服务将视为您理解并同意接受本协议及《{{
        appName
      }}隐私协议》的全部约定内容。
    </div>
    <div class="title">第3条 会员权益</div>
    <div class="line">
      您成为WE+减脂会员后，可享受WE+减脂会员多项增值服务，具体以{{
        appName
      }}APP公布的信息为准。为更好的向会员提供服务，{{
        appName
      }}有权基于自身业务发展需要调整全部或部分会员权益。{{
        appName
      }}就前述权益调整将在相应服务页面进行通知或公告，您可以通过{{
        appName
      }}APP查询最新的会员权益内容。
    </div>
    <div class="title">第4条 会员使用注意事项</div>
    <div class="line">
      4.1在成为会员之前，您必须先根据真实、准确、合法且有效的个人信息注册成为{{
        appName
      }}用户，在成功登录{{ appName }}账号的基础上申请开通会员服务，否则{{
        appName
      }}有权拒绝您的会员申请。用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽，用户需承担因此引起的相应责任及后果。
    </div>
    <div class="line">
      4.2服务开通后，用户应谨慎合理的保存、使用其用户名和密码，不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，同时{{
        appName
      }}在该种情况下有权做出独立判断，可采取暂停或关闭用户参与资格等措施。
    </div>
    <div class="bold line">
      4.3用户同意，其应合理使用其享有的会员权益，除为实现用户自身的会员利益外，不得利用其享有的权益非法获利，不得以任何形式售卖其所享有的权益，不得滥用其所享有的权益，如因用户不当行为致{{
        appName
      }}合理怀疑的或判定的，{{
        appName
      }}有权暂停或关闭用户该活动的权益，此外，用户需承担因此引起的相应责任及后果。
    </div>
    <div>
      4.4为方便您使用会员服务，您同意并授权平台运营方将您在账户注册/激活、使用会员服务过程中提供、形成的信息传递给向您提供其他服务的关联公司，或从提供其他服务的关联公司处获取您在注册/激活、使用其他服务期问提供、形成的信息。除此之外，平台运营方将予以严格保密涉及您姓名、地址、电子邮箱、账号和电话号码等个人信息的，除非：
    </div>
    <div>（1）事先获得您的明确授权；</div>
    <div>（2）为了履行您的订单或保护您的合法权利所必须；</div>
    <div>（3）为了进行大数据分析，以优化营销方案、优惠及个性化的服务</div>
    <div class="line"
      >（4）相应的法律程序及相关政府部门要求{{ appName }}提供。</div
    >
    <div class="title">第5条 协议更新及用户关注义务</div>
    <div class="bold line">
      根据国家法律法规变化及网站运营需要，{{
        appName
      }}有权以公告的方式进行不定期地制定、修改本协议及/或相关服务规则，暂停、取消和修改本协议条款，修改后的协议一旦被公告在本站上即生效，并代替原来的协议。用户应及时关注不时发布的各项服务规则及本协议的变更。若不同意相关规则及条款修改的，应及时终止与本站的协议。如用户继续使用本网站提供的服务的，即视为同意更新后的协议。{{
        appName
      }}建议您在使用本站之前阅读本协议及本站的公告。
    </div>
    <div class="title">第6条 法律管辖和适用</div>
    <div class="line">
      本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律(但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。<span
        class="bold"
        >如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向长沙市开福区人民法院提起诉讼。
      </span></div
    >
    <div class="title">第7条 其他</div>
    <div class="line"
      >7.1如因不可抗力或其它{{ appName }}无法控制的原因使{{
        appName
      }}所涉活动服务无法及时提供或无法按本协议进行的，{{
        appName
      }}会合理地尽力协助处理善后事宜。</div
    >
    <div class="line"
      >7.2用户除遵守本会员服务协议外，仍应同时遵守《{{
        appName
      }}用户协议》。</div
    >
    <div class="line"
      >7.3会员用户自购买之日起开始计算到正式用户到期当日自动终止。月卡会员有效期为31天（自开通当日起计算）；季卡会员有效期为93天（自开通当日起计算）；年卡会员有效期为372天（自开通当日起计算）。
    </div>
    <div class="line"
      >7.4本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请用户着重阅读。
    </div>
  </div>
</template>
<script>
import HTTP from '@/request/index'
import AppNavbar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    AppNavbar
  },
  data() {
    return {
      appName: 'betterWE星球',
      companyName: '长沙健盟网络科技有限公司'
    }
  },
  async created() {
    let appName = this.$route.query.appName
    let companyName = this.$route.query.companyName
    this.appName = appName ?? this.appName
    this.companyName = companyName ?? this.companyName
    /* 因为app 98版本会员协议填写的是测试环境 所以需要98版本时跳转至正式环境 */
    let version = await this.$betterwe.getAppVersion().catch(() => {})
    if (HTTP.curEv() == 'test' && version == 98) {
      let url = 'https://btvue.gymcity.com.cn/betterwe/vip-agreement'
      location.replace(url)
    }
  },
  methods: {
    bindBack() {
      this.$betterwe.onAppCloseRoute()
    }
  }
}
</script>
<style lang="scss" scoped>
.agreement {
  padding: 30px 20px;
  color: rgba(0, 0, 0, 0.8);
  font-size: 12px;

  .title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .line {
    margin-bottom: 20px;
  }

  .bold {
    font-weight: 600;
  }
}
</style>
